var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0892 6.42516L12.0892 6.4252L12.0936 6.42063C12.4637 6.0378 12.47 5.42771 12.0892 5.04684C11.7107 4.66839 11.0893 4.66839 10.7108 5.04684L6.864 8.89367L5.28916 7.31883C4.91072 6.94039 4.28928 6.94039 3.91084 7.31883C3.53239 7.69728 3.53239 8.31872 3.91084 8.69717L6.17484 10.9612C6.35636 11.1427 6.60341 11.247 6.864 11.247C7.12459 11.247 7.37164 11.1427 7.55316 10.9612L12.0892 6.42516ZM0.375 8C0.375 3.79911 3.79911 0.375 8 0.375C12.2009 0.375 15.625 3.79911 15.625 8C15.625 12.2009 12.2009 15.625 8 15.625C3.79911 15.625 0.375 12.2009 0.375 8Z",
    fill: "#2DB98D",
    stroke: "#2DB98D",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidated);
export default __webpack_public_path__ + "static/media/validated.93425937bba2f0a0894343693d46818d.svg";
export { ForwardRef as ReactComponent };